import React, { Component, createRef } from "react";
// // Editable
import { success, info, error, warning, clear } from "toastr";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from "moment/moment";
import { categoriTypes, cubeList, process } from "../StaticData.js";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addCubes,
  getCubeBelts,
  getCubeId,
  getCubesWithProcessId,
  getProcess,
  getUserApi,
  updateCubes,
  updateFillerStock,
} from "api";
import { withTranslation } from "react-i18next";

class EditFillingProcess extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      colVal: 0,
      rowVal: 0,
      isSubmit: false,
      processList:[],
      flag: null,
      submitTrue: false,
      addRowThroughBarcode: "",

      remarks: props?.location?.query ? props.location.query.data.remarks : "",
      usedCylinder: 2,
      beltId: "",
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: 1, data: null },
      machineOperatorId: props?.location?.query
        ? props?.location?.query?.data.machineOperatorId
        : "",
      category: "",
      processId:
        props?.location?.query?.isEdit == 1
          ? ""
          : props?.location?.query?.data?.processId,
      stockList: [],
      JangadList: [],
      userList: [],
      typingTimeout: null,
      cylinder1:
        props.location.query && props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.cubeInformations
              .filter(x => {
                return x.cylinderNo == 1;
              })
              .map(y => {
                return {
                  cubeBeltId: y.cubeBeltId,
                  isNew: false,
                  id: y.id,
                  jangadId: y.jangadId,
                  mainJangadId: y.mainJangadId,
                  mainJangad: y.mainJangad,
                  dataEntryStockId: y.dataEntryStockId,
                  graderStockId: y.graderStockId,
                  assignGraderToFillerStockId: y.assignGraderToFillerStockId,
                  fillerStockId: y.fillerStockId,
                  stockDataEntryInWardId: y.stockDataEntryInWardId,
                  stockGraderInWardId: y.stockGraderInWardId,
                  stockGraderInWard: y.stockGraderInWard,
                  assignGraderToFillerInWardId: y.assignGraderToFillerInWardId,
                  stockFillerInWardId: y.stockFillerInWardId,
                  diamondId: y.stockFillerInWardId,
                  srNo: {
                    label: y.stockDataEntryInWard.srNo,
                    value: y.stockFillerInWardId,
                  },
                  shape: y.stockFillerInWard.stockGraderInWard.shape.name,
                  weight: y.assignGraderToFillerInWard.weight,
                  category: y.mainJangad.category.name,
                  cylinderNo: y.cylinderNo,
                };
              })
          : [],
      cylinder2:
        props.location.query && props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.cubeInformations
              .filter(x => {
                return x.cylinderNo == 2;
              })
              .map(y => {
                return {
                  cubeBeltId: y.cubeBeltId,
                  isNew: false,
                  id: y.id,
                  jangadId: y.jangadId,
                  mainJangadId: y.mainJangadId,
                  dataEntryStockId: y.dataEntryStockId,
                  graderStockId: y.graderStockId,
                  assignGraderToFillerStockId: y.assignGraderToFillerStockId,
                  fillerStockId: y.fillerStockId,
                  stockDataEntryInWardId: y.stockDataEntryInWardId,
                  stockGraderInWardId: y.stockGraderInWardId,
                  assignGraderToFillerInWardId: y.assignGraderToFillerInWardId,
                  stockFillerInWardId: y.stockFillerInWardId,
                  stockGraderInWard: y.stockGraderInWard,
                  diamondId: y.stockFillerInWardId,
                  srNo: {
                    label: y.stockDataEntryInWard.srNo,
                    value: y.stockFillerInWardId,
                  },
                  weight: y.assignGraderToFillerInWard.weight,
                  category: y.mainJangad.category.name,
                  cylinderNo: y.cylinderNo,
                };
              })
          : [],
      tray: [],

      notEditableRows1:
        props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.cubeInformations.map(x => x.id)
          : [],
      notEditableRows2:
        props?.location?.query?.isEdit != 1
          ? props?.location?.query?.data.cubeInformations.map(x => x.id)
          : [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }
  JangadList;
  setJangadList() {
    this.setState({
      JangadList: this.state.stockList
        .map(x => {
          return { label: x.mainJangad.name, value: x.mainJangadId };
        })
        .filter(y => {
          let stockFillerInWardsList = this.state.stockList.filter(
            x => x.mainJangadId == y.value
          )[0].stockFillerInWards;
          let cyclinder1 = this.state.cylinder1.filter(
            a => a.mainJangadId == y.value
          );
          let cyclinder2 = this.state.cylinder2.filter(
            a => a.mainJangadId == y.value
          );
          return stockFillerInWardsList.length ==
            cyclinder1.length + cyclinder2.length
            ? false
            : true;
        }),
    });
  }

  _handleKeyDown = async (e, data) => {
    if (e.key === "Enter") {
      console.log(e);
    }
  };

  addRowThroughBarcodeF(data) {
    if (data.includes("$")) {
      let jangadData = data.split("-")[1].split("&");

      let jangadData1 = jangadData[1].split("$");
      let jangadId = jangadData[0];
      let srNo = jangadData1[0];
      if (
        typeof parseInt(jangadId) == "number" &&
        typeof parseInt(srNo) == "number"
      ) {
        let barCodeData = this.state.stockList.filter(
          x => parseInt(x.mainJangadId.split("JANGAD")[1]) == parseInt(jangadId)
        );
        if (barCodeData.length > 0) {
          let srNoMatch = barCodeData[0].stockFillerInWards.filter(
            y => y.stockDataEntryInWard.srNo == parseInt(srNo)
          );
          if (Array.isArray(srNoMatch) && srNoMatch.length > 0) {
            srNoMatch = srNoMatch[0];
            let matchElement = this.state.cylinder1.filter(y => {
              return (
                y.mainJangadId == srNoMatch.mainJangadId &&
                y.srNo.label == srNoMatch.stockDataEntryInWard.srNo
              );
            });
            if (Array.isArray(matchElement) && matchElement.length > 0) {
              this.setState({ addRowThroughBarcode: "" }, () =>
                console.log(this.state.addRowThroughBarcode)
              );
              warning("Diamond Already Exits");
            } else
              this.setState(
                {
                  cylinder1: [
                    ...this.state.cylinder1,
                    {
                      id: this.state.cylinder1.length + 1,
                      isNew: true,
                      jangadId: srNoMatch.jangadId,
                      mainJangadId: srNoMatch.mainJangadId,
                      dataEntryStockId: srNoMatch.dataEntryStockId,
                      graderStockId: srNoMatch.graderStockId,
                      assignGraderToFillerStockId:
                        srNoMatch.assignGraderToFillerStockId,
                      fillerStockId: srNoMatch.fillerStockId,
                      stockDataEntryInWardId: srNoMatch.stockDataEntryInWardId,
                      stockGraderInWardId: srNoMatch.stockGraderInWardId,
                      stockGraderInWard: srNoMatch.stockGraderInWard,
                      assignGraderToFillerInWardId:
                        srNoMatch.assignGraderToFillerInWardId,
                      stockFillerInWardId: srNoMatch.id,
                      diamondId: srNoMatch.id,
                      srNo: {
                        label: srNoMatch.stockDataEntryInWard.srNo,
                        value: srNoMatch.id,
                      },
                      weight: srNoMatch.assignGraderToFillerInWard.weight,
                      category: barCodeData[0].mainJangad.category.name,
                      cylinderNo: 1,
                    },
                  ],
                  notEditableRows1: [
                    ...this.state.cylinder1.map(x => x.id),
                    this.state.cylinder1.length + 1,
                  ],
                },
                () => {
                  this.setState({ addRowThroughBarcode: "" }, () =>
                    console.log(this.state.addRowThroughBarcode)
                  );
                }
              );
          } else {
            error(`Diamond is not match with process ${this.state.processId}`);
            this.setState({ addRowThroughBarcode: "" }, () =>
              console.log(this.state.addRowThroughBarcode)
            );
          }
        } else {
          error(`Diamond is not match with process ${this.state.processId}`);
          this.setState({ addRowThroughBarcode: "" }, () =>
            console.log(this.state.addRowThroughBarcode)
          );
        }
      }
    }
  }
  addRow(cylinder, notEditableRows) {
    this.setState({
      [cylinder]: [
        ...this.state[cylinder],
        {
          id: this.state[cylinder].length + 1,
          isNew: true,
          jangadId: "",
          mainJangadId: "",
          mainJangad: {},
          dataEntryStockId: "",
          graderStockId: "",
          assignGraderToFillerStockId: "",
          fillerStockId: "",
          stockDataEntryInWardId: "",
          stockGraderInWardId: "",
          assignGraderToFillerInWardId: "",
          stockFillerInWardId: "",
          diamondId: "",
          srNo: 0,
          weight: 0,
          shape: "",
          category: "",
          cylinderNo: cylinder == "cylinder1" ? 1 : 2,
        },
      ],
      [notEditableRows]: [
        ...this.state[cylinder].map(x => x.id),
        this.state[cylinder].length + 1,
      ],
    });
  }

  validateTable() {
    for (let i = 0; i < this.state.cylinder1.length; i++) {
      let e = this.state.cylinder1[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  validateTable1() {
    for (let i = 0; i < this.state.cylinder2.length; i++) {
      let e = this.state.cylinder2[i];
      if (e.srNo == "") {
        return false;
      }
    }
    return true;
  }

  async componentDidMount() {
    const process = await getProcess();

    if (process && process.data) {
      this.setState({
        processList: process.data,
      });
    }


    const beltId = await getCubeId()
    console.log(beltId)
    if(beltId && beltId.data){
      this.setState({
        beltId: beltId.data.id
      })
    }

    this.validateTable();
    this.validateTable1();
    let factoryId = JSON.parse(localStorage.getItem("authUser")).factoryId;
    const machineOperator = await getUserApi({
      factoryId: factoryId ? factoryId : null,
      roleId: "ROLE0000004",
    });
    this.setState({
      userList: machineOperator.data.users,
    });
    if (this.state.props.isEdit == 2) {
      let processId = this.state.props.data.processId;
      let cubeBeltId = this.state.props.data.id;
      const data = await getCubesWithProcessId({
        id: processId,
        cubeBeltId: cubeBeltId,
        fillerId: JSON.parse(localStorage.getItem("authUser")).id,
      });
      this.setState(
        {
          stockList: data.data.fillerStocks,
        },
        () => {
          this.setState(
            {
              JangadList: this.state.stockList.map(x => {
                return { label: x.mainJangad.name, value: x.mainJangadId };
              }),
            },
            () => {
              this.setJangadList();
            }
          );
        }
      );
    }
    // const s = await this.getStockList();
  }

  async getStockList() {
    // const stock = await getCubeBelts({ page:null, limit:null});
  }

  async getCube() {
    const stock = await getCubesWithProcessId({
      id: this.state.processId,
      cubeBeltId: null,
      fillerId: JSON.parse(localStorage.getItem("authUser")).id,
    });
    this.setState(
      {
        JangadList: stock.data.fillerStocks.map(x => {
          return { label: x.mainJangad.name, value: x.mainJangadId };
        }),
        stockList: stock.data.fillerStocks,
      },
      () => {
        this.setJangadList();
      }
    );
  }

  deleteRow(rowIndex, name, row, notEditableRows) {
    this.state[name].splice(rowIndex, 1);
    // this.state[notEditableRows].splice(this.state[notEditableRows].indexOf(row.id), 1);
    this.setState(
      {
        [name]: this.state[name].map((x, index) => x),
        [notEditableRows]: this.state[name].map((x, index) => x.id),
      },
      () => this.setJangadList()
    );
  }

  async resetValue() {
    this.setState({
      cylinder1: [],
      cylinder2: [],
      isSubmit: false,
      submitTrue: false,
      machineOperatorId: "",
      remarks: "",
      usedCylinder: 2,
      beltId: "",
      processId: "",
    });
    this.componentDidMount();
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let payload = {
        usedCylinder: values.usedCylinder,
        processId: values.processId,
        remarks: this.state.remarks,
        cubeId: this.state.beltId,
        ...values,
        cubeInformations: [
          ...this.state.cylinder1.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWard: x.stockGraderInWard,
              stockGraderInWardId: x.stockGraderInWardId,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 1,
            };
          }),
          ...this.state.cylinder2.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 2,
            };
          }),
        ],
      };
      const data = await addCubes(payload);
      this.setState({
        usedCylinder: values.usedCylinder
      });

      if (data.success == true) {
        this.setState({
          submitTrue: true,
        });
      }
    } else {
      let payload = {
        usedCylinder: values.usedCylinder,
        processId: values.processId,
        remarks: this.state.remarks,
        ...values,
        machineOperatorId: this.state.machineOperatorId,
        cubeInformations: [
          ...this.state.cylinder1.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              stockGraderInWard: x.stockGraderInWard,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 1,
            };
          }),
          ...this.state.cylinder2.map(x => {
            return {
              ...x,
              weight: x.weight,
              jangadId: x.jangadId,
              mainJangadId: x.mainJangadId,
              dataEntryStockId: x.dataEntryStockId,
              graderStockId: x.graderStockId,
              assignGraderToFillerStockId: x.assignGraderToFillerStockId,
              fillerStockId: x.fillerStockId,
              stockDataEntryInWardId: x.stockDataEntryInWardId,
              stockGraderInWardId: x.stockGraderInWardId,
              stockGraderInWard: x.stockGraderInWard,
              assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
              stockFillerInWardId: x.srNo.value,
              cylinderNo: 2,
            };
          }),
        ],
      };
      const data = await updateCubes({
        id: this.state.props.data.id,
        data: payload,
      });
    }
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }
  render() {
    document.title = "filler flow";
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: `${this.props.t("Total Pieces")}: ${
          this.state.cylinder1.length
        }`,
        hidden:true
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        footer: `${this.props.t("Total")}: ${
          this.state.cylinder1.length
        }`,
        editor: {
          type: Type.SELECT,
          options: this.state.JangadList,
        },
        formatter: (cell, row) => {
          if (cell && this.state.stockList.length) {
            let jangad = this.state.stockList.filter(
              x => x.mainJangadId == row.mainJangadId
            )[0].mainJangad;

            row.category = jangad.category.name;
            row.mainJangad = jangad;
          }
          if (cell == "") {
            return "NONE";
          }
          if (cell.includes("JANGAD")) {
            return row.mainJangad.name;
          } else {
            return row.mainJangad.name + "-" + row.stockDataEntryInWard.srNo;
          }
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.stockList,
        },
        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          if (row.mainJangadId) {
            let srNodata = this.state.stockList
              .filter(x => x.mainJangadId == row.mainJangadId)[0]
              .stockFillerInWards.filter(x => {
                return this.state.cylinder1.filter(y => y.srNo.value == x.id)
                  .length ||
                  this.state.cylinder2.filter(y => y.srNo.value == x.id).length
                  ? false
                  : true;
              })
              .map(x => {
                return {
                  label: x.stockDataEntryInWard.srNo,
                  value: x.id,
                  weight: x.assignGraderToFillerInWard.weight,
                  jangadId: x.jangadId,
                  mainJangadId: x.mainJangadId,
                  dataEntryStockId: x.dataEntryStockId,
                  graderStockId: x.graderStockId,
                  assignGraderToFillerStockId: x.assignGraderToFillerStockId,
                  fillerStockId: x.fillerStockId,
                  stockDataEntryInWardId: x.stockDataEntryInWardId,
                  stockGraderInWardId: x.stockGraderInWardId,
                  stockGraderInWard: x.stockGraderInWard,
                  assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
                  stockFillerInWardId: x.stockFillerInWardId,
                };
              });
            return (
              <div className="mb-3 select2-container">
                <Select
                  value={row.srNo}
                  onChange={e => {
                    row.srNo = e;
                    row.weight = e.weight;
                    row.jangadId = e.jangadId;
                    row.mainJangadId = e.mainJangadId;
                    row.dataEntryStockId = e.dataEntryStockId;
                    row.graderStockId = e.graderStockId;
                    row.assignGraderToFillerStockId =
                      e.assignGraderToFillerStockId;
                    row.fillerStockId = e.fillerStockId;
                    row.stockDataEntryInWardId = e.stockDataEntryInWardId;
                    row.stockGraderInWardId = e.stockGraderInWardId;
                    row.stockGraderInWard = e.stockGraderInWard;
                    row.shape = e.stockGraderInWard.shape.name;
                    row.assignGraderToFillerInWardId =
                      e.assignGraderToFillerInWardId;
                    row.stockFillerInWardId = e.stockFillerInWardId;
                    this.setState({ flag: e });
                  }}
                  options={srNodata}
                />
              </div>
            );
          }

          return "NONE";
        },
        formatter: (cell, row) => {
          if (row.srNo) {
            return cell.label;
          } else {
            return "NONE";
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        footer: "",
        editable: false,
      },
      {
        dataField: "shape",
        text: `${this.props.t("Shape")}`,
        footer: "",
        editable: false,
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        editable: false,
        footer: columnData =>
          `${this.props.t("Total Weight")}: ${columnData
            .reduce((acc, item) => acc + item, 0)
            .toFixed(2)}`,
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              <button
                type="button"
                className="bg-transparent border-0 ms-3"
                onClick={e => {
                  this.deleteRow(
                    rowIndex,
                    "cylinder1",
                    row,
                    "notEditableRows1"
                  );
                }}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
             
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => {
          return (
            <div className="btn-group">
              <button
                className="bg-transparent border-0 ms-3"
                type="button"
                onClick={e => {
                  if (e.key != "Enter")
                    this.deleteRow(
                      rowIndex,
                      "cylinder1",
                      row,
                      "notEditableRows1"
                    );
                }}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
             
            </div>
          );
        },
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.JangadList,
        },
        formatter: (cell, row) => {
          if (cell && this.state.stockList.length) {
            row.category = this.state.stockList.filter(
              x => x.mainJangadId == row.mainJangadId
            )[0].mainJangad.category.name;
          }
          if (cell == "") {
            return "NONE";
          } else {
            return cell;
          }
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.stockList,
        },
        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          if (row.mainJangadId) {
            let srNodata = this.state.stockList
              .filter(x => x.mainJangadId == row.mainJangadId)[0]
              .stockFillerInWards.filter(x => {
                return this.state.cylinder1.filter(y => y.srNo.value == x.id)
                  .length ||
                  this.state.cylinder2.filter(y => y.srNo.value == x.id).length
                  ? false
                  : true;
              })
              .map(x => {
                console.log(x)
                return {
                  label: x.stockDataEntryInWard.srNo,
                  value: x.id,
                  weight: x.assignGraderToFillerInWard.weight,
                  jangadId: x.jangadId,
                  mainJangadId: x.mainJangadId,
                  dataEntryStockId: x.dataEntryStockId,
                  graderStockId: x.graderStockId,
                  assignGraderToFillerStockId: x.assignGraderToFillerStockId,
                  fillerStockId: x.fillerStockId,
                  stockDataEntryInWardId: x.stockDataEntryInWardId,
                  stockGraderInWardId: x.stockGraderInWardId,
                  stockGraderInWard: x.stockGraderInWard,
                  assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
                  stockFillerInWardId: x.stockFillerInWardId,
                };
              });
            return (
              <div className="mb-3 select2-container">
                <Select
                  value={row.srNo}
                  onChange={e => {
                    console.log(e)
                    row.srNo = e;
                    row.weight = e.weight;
                    row.jangadId = e.jangadId;
                    row.mainJangadId = e.mainJangadId;
                    row.dataEntryStockId = e.dataEntryStockId;
                    row.graderStockId = e.graderStockId;
                    row.assignGraderToFillerStockId =
                      e.assignGraderToFillerStockId;
                    row.fillerStockId = e.fillerStockId;
                    row.stockDataEntryInWardId = e.stockDataEntryInWardId;
                    row.stockGraderInWardId = e.stockGraderInWardId;
                    row.assignGraderToFillerInWardId =
                      e.assignGraderToFillerInWardId;
                    row.stockFillerInWardId = e.stockFillerInWardId;
                    this.setState({ flag: e });
                  }}
                  options={srNodata}
                />
              </div>
            );
          }
          return "NONE";
        },
        formatter: (cell, row) => {
          if (row.srNo) {
            return cell.label;
          } else {
            return "NONE";
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "category",
        text: `${this.props.t("Category")}`,
        footer: "",
        editable: false,
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        footer: "",
        editable: false,
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows2.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows2: [
                        ...this.state.notEditableRows2,
                        row.id,
                      ],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows2: this.state.notEditableRows2.filter(
                        x => x != row.id
                      ),
                    });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                type="button"
                className="bg-transparent border-0 ms-3"
                onClick={() => {
                  this.deleteRow(
                    rowIndex,
                    "cylinder2",
                    row,
                    "notEditableRows2"
                  );
                }}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows2.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setJangadList();
                    this.setState({
                      notEditableRows2: [
                        ...this.state.notEditableRows2,
                        row.id,
                      ],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows2: this.state.notEditableRows2.filter(
                        x => x != row.id
                      ),
                    });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                type="button"
                className="bg-transparent border-0 ms-3"
                onClick={() =>
                  this.deleteRow(rowIndex, "cylinder2", row, "notEditableRows2")
                }
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
      },
    ];

    document.title = "add party";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("Edit Filling Process (Belt)")}`}
            />
            <Formik
              enableReinitialize={true}
              initialValues={
                this.state.props.isEdit == 1
                  ? {
                      cubeId: this.state.beltId,
                      processId: (this.state && this.state.processId) || "",
                      usedCylinder:
                        (this.state && this.state.usedCylinder) || "",
                      machineOperatorId: this.state.machineOperatorId,
                      remarks: this.state.remarks,
                    }
                  : {
                    cubeId: this.state.props.data.cubeId.substring(0, 4) == 'BELT' ? this.state.props.data.cubeId.slice(4) : this.state.props.data.cubeId,
                      processId: this.state.props.data.processId,
                      usedCylinder: this.state.props.data.usedCylinder,
                      machineOperatorId:
                        this.state.props.data.machineOperatorId,
                      remarks: this.state.remarks,
                    }
              }
              validationSchema={Yup.object().shape({
                cubeId: Yup.string().required("This Value is Required"),
                processId: Yup.string().required("This Value is Required"),
                usedCylinder: Yup.string().required("This Value is Required"),
                machineOperatorId: Yup.string().required(
                  "This Value is Required"
                ),
                remarks: Yup.string().max(512).nullable().notRequired(),
              })}
            >
              {({ errors, status, touched, isValid, values, validateForm }) => (
                <Form className="needs-validation">
                  <Card className="px-4">
                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          {this.props.t("Edit Filling Process (Belt)")}
                        </h4>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="cubeId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Belt Id")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.cubeId && touched.cubeId
                              ? " is-invalid"
                              : "")
                          }
                          readOnly={true}
                          name="cubeId"
                          type="text"
                          placeholder="Enter Belt Id"
                        />
                        <ErrorMessage
                          name="cubeId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="processId"
                        className="col-lg-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Assigned Process")}
                        </h5>
                      </Label>
                      <div className="col-lg-10 col-12">
                        <Field
                          className={
                            this.state.props.isEdit == 3
                              ? "form-control fs-5" +
                                (errors.processId && touched.processId
                                  ? " is-invalid"
                                  : "")
                              : "form-control form-select fs-5" +
                                (errors.processId && touched.processId
                                  ? " is-invalid"
                                  : "")
                          }
                          value={this.state.processId}
                          onChange={e => {
                            this.setState(
                              {
                                cylinder1: [],
                                cylinder2: [],
                                notEditableRows1: [],
                                notEditableRows2: [],
                                JangadList: [],
                                stockList: [],
                                processId: e.target.value,
                              },
                              () => this.getCube()
                            );
                          }}
                          disabled={this.state.props.isEdit == 3 ? true : false}
                          name="processId"
                          as="select"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            select
                          </option>
                          {this.state.processList?.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="processId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="machineOperatorId"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Machine Operator")}
                        </h5>
                      </Label>
                      <div className="col-md-10 col-12">
                        <Field
                          className={
                            this.state.props.isEdit == 3
                              ? "form-control fs-5" +
                                (errors.machineOperatorId &&
                                touched.machineOperatorId
                                  ? " is-invalid"
                                  : "")
                              : "form-control form-select fs-5" +
                                (errors.machineOperatorId &&
                                touched.machineOperatorId
                                  ? " is-invalid"
                                  : "")
                          }
                          value={this.state.machineOperatorId}
                          onChange={e => {
                            this.setState({
                              machineOperatorId: e.target.value,
                            });
                          }}
                          name="machineOperatorId"
                          as="select"
                          disabled={this.state.props.isEdit == 3 ? true : false}
                        >
                          <option value="" disabled>
                            select
                          </option>
                          {this.state.userList.map(x => (
                            <option key={x.id} value={x.id}>
                              {x.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="machineOperatorId"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <Label
                        htmlFor="remarks"
                        className="col-md-2 col-form-label"
                      >
                        <h5 className="text-secondary fw-bold">
                          {this.props.t("Filler Notes")}
                        </h5>
                      </Label>
                      <div className="col-md-10">
                        <Field
                          className={
                            "form-control fs-5" +
                            (errors.remarks && touched.remarks
                              ? " is-invalid"
                              : "")
                          }
                          value={this.state.remarks}
                          onChange={e => {
                            this.setState({
                              remarks: e.target.value,
                            });
                          }}
                          type="text"
                          name="remarks"
                          as="textarea"
                          rows="5"
                          placeholder="Please Take of HPHT First Priority"
                          disabled={this.state.props.isEdit == 3 ? true : false}
                        />
                        <ErrorMessage
                          name="remarks"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>

                    <div>
                      <table>
                        <tr>
                          {" "}
                          {(() => {
                            let tdArrray = [];
                            for (
                              let j = 0;
                              j < this.state.cylinder1.length;
                              j++
                            ) {
                              tdArrray.push(
                                <td className="p-2">
                                  <div className="d-block text-center">
                                    <div>{j + 1}</div>
                                    <div className="c-bg w-100 h-100 rounded-circle p-4"></div>
                                  </div>
                                </td>
                              );
                            }
                          })()}
                        </tr>
                        <tr>
                          {(() => {
                            let tdArrray = [];
                            for (
                              let j = 0;
                              j < this.state.cylinder2.length;
                              j++
                            ) {
                              tdArrray.push(
                                <td className="p-2">
                                  <div className="d-block text-center">
                                    <div>{j + 1}</div>
                                    <div className="c-bg w-100 h-100 rounded-circle p-4"></div>
                                  </div>
                                </td>
                              );
                            }
                          })()}
                        </tr>
                      </table>
                    </div>

                    <div className="d-lg-flex d-block justify-content-between pt-3">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                          <span className="d-inline">
                            {" "}
                            {this.props.t("Barcode Scanning")}
                          </span>
                          {this.state.processId != "" &&
                          this.state.machineOperatorId != "" ? (
                            <input
                              className="form-control d-inline fs-5"
                              value={this.state.addRowThroughBarcode}
                              onKeyUp={e => {
                                e.preventDefault();
                              }}
                              onChange={e => {
                                this.setState(
                                  { addRowThroughBarcode: e.target.value },
                                  () =>
                                    this.addRowThroughBarcodeF(
                                      this.state.addRowThroughBarcode
                                    )
                                );
                              }}
                            ></input>
                          ) : (
                            <input
                              className="form-control  d-inline fs-5"
                              readOnly={true}
                              onClick={async e => {
                                error(
                                  "Please select process and machine operator"
                                );
                              }}
                              value={this.state.addRowThroughBarcode}
                              onChange={e => {
                                this.setState(
                                  { addRowThroughBarcode: e.target.value },
                                  () =>
                                    this.addRowThroughBarcodeF(
                                      this.state.addRowThroughBarcode
                                    )
                                );
                              }}
                            ></input>
                          )}
                        </h4>
                      </div>
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-5 col-lg-6">
                          <Label
                            htmlFor="usedCylinder"
                            className="col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Total Used Cylinder Kit")}
                            </h5>
                          </Label>
                        </div>
                        <div className="col-12 col-sm-5 col-lg-6">
                          <Field
                            className={
                              "form-control fs-5" +
                              (errors.usedCylinder && touched.usedCylinder
                                ? " is-invalid"
                                : "")
                            }
                            disabled={
                              this.state.props.isEdit == 3 ? true : false
                            }
                            name="usedCylinder"
                            type="text"
                            placeholder="Enter Belt Id"
                          ></Field>
                          <ErrorMessage
                            name="usedCylinder"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between pt-5">
                      <h3 className="fw-bold pb-3 text-black">
                        {/* {this.props.t("First Cylinder Kit")} */}
                      </h3>
                      {this.state.props.isEdit == 3 ? (
                        ""
                      ) : (
                        <>
                          <button
                            type="button"
                            className="bg-transparent border-0"
                            onClick={() => {
                              if (this.state.processId)
                                this.addRow("cylinder1", "notEditableRows1");
                              else info("First select Process");
                            }}
                          >
                            <img
                              src="images/dashboard-images/addRow.svg"
                              alt="add Row"
                            />
                          </button>
                        </>
                      )}
                    </div>
                    {this.state.props.isEdit == 1 && (
                      <div className="table-responsive pt-3">
                        <BootstrapTable
                          keyField="id"
                          classes="foo"
                          headerClasses="background-light fs-5"
                          footerClasses="background-light fs-5"
                          data={this.state.cylinder1}
                          columns={this.columns1}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            // nonEditableRows: () => this.state.notEditableRows1,
                            afterSaveCell: () => {
                              this.setJangadList();
                              this.setState({
                                cylinder1: [...this.state.cylinder1],
                              });
                            },
                          })}
                        />
                      </div>
                    )}
                    {this.state.props.isEdit == 2 && (
                      <div className="table-responsive pt-3">
                        <BootstrapTable
                          keyField="id"
                          classes="foo"
                          headerClasses="background-light fs-5"
                          footerClasses="background-light fs-5"
                          data={this.state.cylinder1}
                          columns={this.columns1}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            // nonEditableRows: () => this.state.notEditableRows1,
                            afterSaveCell: () => {
                              this.setJangadList();
                              this.setState({
                                cylinder1: [...this.state.cylinder1],
                              });
                            },
                          })}
                        />
                      </div>
                    )}
                    {this.state.props.isEdit == 3 && (
                      <div className="table-responsive pt-3">
                        <BootstrapTable
                          keyField="id"
                          classes="foo"
                          headerClasses="background-light fs-5"
                          footerClasses="background-light fs-5"
                          data={this.state.cylinder1}
                          columns={this.columns1}
                        />
                      </div>
                    )}
                    {this.state.props.isEdit == 1 &&
                    this.state.submitTrue == false ? (
                      <>
                        <div className="col-md-12 text-end mb-4">
                          <Button
                            color="primary"
                            type="submit"
                            className="fs-4 px-5"
                            onClick={async e => {
                              this.setState({ isSubmit: true }, async () => {
                                if (
                                  e.nativeEvent.detail >= 1 &&
                                  this.validateTable() &&
                                  this.validateTable1()
                                ) {
                                  await validateForm()
                                    .then(data => {
                                      if (Object.keys(data).length == 0) {
                                        this.handleSubmit(event, values);
                                      }
                                    })
                                    .catch(err => console.log("err =>", err));
                                }
                              });
                            }}
                          >
                            Submit
                          </Button>
                        </div>
                      </>
                    ) : (
                      this.state.props.isEdit == 1 && (
                        <div className="col-md-12 text-end mb-4">
                          <Button
                            color="primary"
                            type="reset"
                            className="fs-4 px-5"
                            onClick={() => {
                              this.resetValue();
                            }}
                          >
                            Reset
                          </Button>
                        </div>
                      )
                    )}
                    {this.state.props.isEdit == 2 && (
                      <>
                        <div className="col-md-12 text-end mb-4">
                          <Button
                            color="primary"
                            onClick={() => {
                              validateForm()
                                .then(data => {
                                  if (Object.keys(data).length == 0) {
                                    this.handleSubmit(event, values);
                                  }
                                })
                                .catch(err => console.log(err));
                            }}
                            className="fs-4 px-5"
                          >
                            Update
                          </Button>
                        </div>
                      </>
                    )}

                    {this.state.props.isEdit == 3 && (
                      <>
                        <div className="col-md-12 text-end mb-4">
                          <Button
                            color="primary"
                            onClick={() => {
                              this.props.history.goBack();
                            }}
                            className="fs-4 px-5"
                          >
                            Back
                          </Button>
                        </div>
                      </>
                    )}
                  </Card>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(EditFillingProcess);
